module.exports = __webpack_public_path__ + "static/media/logo.71f6b078.svg";